import { CoreMenu } from '@core/types';
import { RoleType } from '../server/enums/role-type';

export const frontendMenu: CoreMenu[] = [
	{
		id: 'dashboard',
		title: 'Dashboard',
		translate: 'menu_fo_dashboard',
		type: 'item',
		icon: 'home',
		url: 'dashboard',
		exactMatch: true,
		roles: [RoleType.Trainee, RoleType.Tutor, RoleType.OperationalTutor],
	},
	{
		id: 'tutor-trainees',
		title: 'Lista Specializzandi',
		translate: 'menu_fo_trainees_list',
		type: 'item',
		icon: 'users',
		url: 'dashboard/specializzandi',
		exactMatch: true,
		roles: [RoleType.Tutor, RoleType.OperationalTutor],
	},
	{
		id: 'student-dashboard',
		title: 'Dashboard',
		translate: 'menu_fo_trainee_dashboard',
		type: 'item',
		icon: 'home',
		url: 'student',
		exactMatch: true,
		roles: [RoleType.Student],
	},
	{
		id: 'student-profile',
		title: 'Il Mio Profilo',
		translate: 'menu_fo_trainee_profile',
		type: 'item',
		icon: 'user',
		url: 'student/profile',
		roles: [RoleType.Student],
	},
	{
		id: 'student-book',
		title: 'Prenota Tirocinio',
		translate: 'menu_fo_trainee_book',
		type: 'item',
		icon: 'calendar',
		url: 'student/book',
		roles: [RoleType.Student],
	},
	{
		id: 'student-manage',
		title: 'Gestione Prenotazioni',
		translate: 'menu_fo_trainee_manage',
		type: 'item',
		icon: 'list',
		url: 'student/manage',
		roles: [RoleType.Student],
	},
	{
		id: 'student-registrations',
		title: 'Registro Attività',
		translate: 'menu_fo_trainee_registrations',
		type: 'item',
		icon: 'clipboard',
		url: 'student/registrations',
		roles: [RoleType.Student],
	},
	{
		id: 'student-info',
		title: 'FAQ e Statistiche',
		translate: 'menu_fo_trainee_info',
		type: 'item',
		icon: 'info',
		url: 'student/info',
		roles: [RoleType.Student],
	},
	{
		id: 'registration',
		title: 'Registrazione',
		translate: 'menu_fo_registration',
		type: 'item',
		icon: 'plus-circle',
		url: 'registration',
		roles: [RoleType.Trainee],
		permissions: ['fe_registration.create'],
	},
	{
		id: 'list-registrations',
		title: 'Lista Registrazioni',
		translate: 'menu_fo_registrations_list',
		type: 'item',
		icon: 'list-check',
		url: 'registrations-list',
		roles: [RoleType.Trainee],
		permissions: ['registrations.view'],
	},
	{
		id: 'my-documents',
		title: 'I Miei Documenti',
		translate: 'menu_fo_my_documents',
		type: 'item',
		icon: 'folder-open',
		url: 'my-documents',
		roles: [RoleType.Trainee, RoleType.Tutor, RoleType.OperationalTutor],
		permissions: ['document_drawer.view'],
	},
];
